import script from "./CreatorAppSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatorAppSettings.vue?vue&type=script&setup=true&lang=js"

import "./CreatorAppSettings.vue?vue&type=style&index=0&id=70ea31a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70ea31a8"]])

export default __exports__